type ItemMapping = {
  translationKey: string;
  icon: string | null; // Icon can be null if missing
};

type IconTranslationMapping = {
  [key: string]: ItemMapping;
};

export const specsMapping: IconTranslationMapping = {
  liftMastAttachment: {
    translationKey: 'MACHINE.PARAMETER.LIFT_MAST_ATTACHMENT',
    icon: 'lift_mast_attachment_type',
  },
  NUMBER_OF_AXLES: {
    translationKey: 'MACHINE.PARAMETER.NUMBER_OF_AXLES',
    icon: 'axle-config',
  },
  CARGO_SPACE_VOLUME: {
    translationKey: 'MACHINE.PARAMETER.CARGO_SPACE_VOLUME',
    icon: 'cargo_space_volume',
  },
  AXLE_CONFIGURATION_FORMULA: {
    translationKey: 'GENERAL.AXLE_CONFIGURATION',
    icon: 'axle-config',
  },
  EMISSION_CLASS: {
    translationKey: 'MACHINE.PARAMETER.EMISSION_CLASS',
    icon: 'emission-class',
  },
  emissionLevel: {
    translationKey: 'MACHINE.PARAMETER.EMISSION_LEVEL',
    icon: 'engine-output',
  },
  MAST_TYPE: {
    translationKey: 'MACHINE.PARAMETER.MAST_TYPE',
    icon: 'lift_mast_type',
  },
  EMPTY_WEIGHT: {
    translationKey: 'MACHINE.PARAMETER.WEIGHT',
    icon: 'weight',
  },
  GROSS_WEIGHT: {
    translationKey: 'MACHINE.PARAMETER.WEIGHT',
    icon: 'weight',
  },
  carryingCapacity: {
    translationKey: 'MACHINE.PARAMETER.CARRYING_CAPACITY',
    icon: null,
  },
  TRANSPORT_WIDTH: {
    translationKey: 'MACHINE.PARAMETER.WIDTH',
    icon: 'width',
  },
  TRANSPORT_LENGTH: {
    translationKey: 'MACHINE.PARAMETER.LENGTH',
    icon: 'length',
  },
  TRANSPORT_HEIGHT: {
    translationKey: 'MACHINE.PARAMETER.HEIGHT',
    icon: 'height',
  },
  BRAND: {
    translationKey: 'GENERAL.BRAND',
    icon: 'filter-icon',
  },
  MODEL: {
    translationKey: 'GENERAL.MODEL',
    icon: 'filter-icon',
  },
  year: {
    translationKey: 'GENERAL.YEAR',
    icon: 'year',
  },
  YEAR_OF_MANUFACTURE: {
    translationKey: 'GENERAL.YEAR_OF_MANUFACTURE',
    icon: 'year',
  },
  WORK_HOURS: {
    translationKey: 'MACHINE.PARAMETER.WORK_HOURS',
    icon: 'speedometer',
  },
  METER_READ_OUT: {
    translationKey: 'GENERAL.METER_READ_OUT',
    icon: 'speedometer',
  },
  ENGINE_OUTPUT: {
    translationKey: 'MACHINE.PARAMETER.ENGINE_OUTPUT',
    icon: 'engine-output',
  },
  liftMast: {
    translationKey: 'MACHINE.PARAMETER.LIFT_MAST',
    icon: 'lift_mast_type',
  },
  LIFT_MAST_ATTACHMENT_TYPE: {
    translationKey: 'MACHINE.PARAMETER.LIFT_MAST_ATTACHMENT_TYPE',
    icon: 'lift_mast_attachment_type',
  },
  TRANSMISSION_TYPE: {
    translationKey: 'MACHINE.PARAMETER.TRANSMISSION',
    icon: 'transmission',
  },
  MAX_PAYLOAD: {
    translationKey: 'MACHINE.PARAMETER.MAX_PAYLOAD',
    icon: 'max_payload',
  },
  MAX_LIFT_CAPACITY: {
    translationKey: 'MACHINE.PARAMETER.MAX_LIFT_CAPACITY',
    icon: 'max_lift_capacity',
  },
  MAXIMUM_LIFT_HEIGHT_MM: {
    translationKey: 'MACHINE.PARAMETER.MAXIMUM_LIFT_HEIGHT',
    icon: 'max_lift_height',
  },
  location: {
    translationKey: 'GENERAL.LOCATION',
    icon: 'location',
  },
  WHEELBASE: {
    translationKey: 'MACHINE.PARAMETER.WHEELBASE',
    icon: 'filter-icon',
  },
  FIRST_DATE_OF_REGISTRATION: {
    translationKey: 'MACHINE.PARAMETER.FIRST_DATE_OF_REGISTRATION',
    icon: 'year',
  }
};

export const specsOrder: string[] = [
  'FIRST_DATE_OF_REGISTRATION',
  'YEAR_OF_MANUFACTURE',
  'METER_READ_OUT',
  'WORK_HOURS',
  'AXLE_CONFIGURATION_FORMULA',
  'NUMBER_OF_AXLES',
  'ENGINE_OUTPUT',
  'EMISSION_CLASS',
  'TRANSMISSION_TYPE',
  'MAX_LIFT_CAPACITY',
  'MAXIMUM_LIFT_HEIGHT_MM',
  'MAST_TYPE',
  'LIFT_MAST_ATTACHMENT_TYPE',
  'TRANSPORT_LENGTH',
  'TRANSPORT_WIDTH',
  'TRANSPORT_HEIGHT',
  'GROSS_WEIGHT',
  'MAX_PAYLOAD',
  'EMPTY_WEIGHT',
  'CARGO_SPACE_VOLUME',
  'WHEELBASE'
];
